import React from "react";

import { Container, Paper, styled, Typography } from '@mui/material';

const Root = styled('div')({

});

const About: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Paper sx={{padding: 2}}>
        <Typography variant="subtitle2">About us</Typography>
      </Paper>
    </Container>
  );
};

export default About;